// extracted by mini-css-extract-plugin
module.exports = {"modal-overlay":"Modal_modal-overlay__hAiQe","open":"Modal_open__m4Cdj","modal":"Modal_modal__nSuXm","modalTitle":"Modal_modalTitle__zXt2d","modal-close":"Modal_modal-close__fQ4pf"};